import React, { useState, useEffect } from 'react';
import './CheckboxGroup.css';
import Checkbox from './Checkbox';
import logComponent from '../../common/logComponent';

export default function CheckboxGroup({ reset, onChange, name, options, initialSelections, horizontal, includeInitialSelectionsOnInitialOnChange }) {
  const [selectedOptions, setSelectedOptions] = useState(initialSelections == null ? [] : options.filter(option => initialSelections.includes(option.text)));
  if (logComponent('CheckboxGroup')) { console.debug('CheckboxGroup rendered'); }


  useEffect(() => {
    if (logComponent('Checkbox')) { console.debug('CheckboxGroup useEffect [reset]'); }
    let newSelectedOptions = initialSelections == null ? [] : options.filter(option => initialSelections.includes(option.text));

    var newCriteria = [];
    if (includeInitialSelectionsOnInitialOnChange && includeInitialSelectionsOnInitialOnChange === true) {
      newCriteria = newSelectedOptions.reduce((prev, curr) => {
        return prev.concat(curr.criteria);
      }, []);
    }

    setSelectedOptions(newSelectedOptions);

    onChange({
      name: name,
      criteria: newCriteria
    });
    

  }, [reset]);


  const handleChange = (option) => {
    if (logComponent('CheckboxGroup')) { console.debug('CheckboxGroup handleChange'); }
    let newSelectedOptions = [];
    
    if (selectedOptions.some(selectedOption => selectedOption.text === option.text)) {
      newSelectedOptions = selectedOptions.filter(selectedOption => selectedOption.text !== option.text);
    } else {
      newSelectedOptions = selectedOptions.concat(option);
    }

    setSelectedOptions(newSelectedOptions);

    onChange({
      name: name,
      criteria: newSelectedOptions.reduce((prev, curr) => {
        return prev.concat(curr.criteria);
      }, [])
    })
  }


  return (
    <div className="Checkbox-Group">
      {(horizontal != null && horizontal === true) &&
        <div className="Checkbox-Group__horizontal">
          {
            options.map(option =>
              <Checkbox
                key={option.text}
                option={option}
                onChange={handleChange}
                checked={selectedOptions.some(selectedOption => selectedOption.text === option.text)} />
            )
          }
        </div>
      }
      {(horizontal == null || horizontal === false) &&
        <div className="Checkbox-Group__vertical">
          {
            options.map(option =>
              <Checkbox
                key={option.text}
                option={option}
                onChange={handleChange}
                checked={selectedOptions.some(selectedOption => selectedOption.text === option.text)} />
            )
          }
        </div>
      }
    </div>
  );
}